
(function (window, document) {

    var nav = document.querySelector('[data-js-nav]');
    var burger = document.querySelector('[data-js-burger]');
    var navBar = document.querySelector('.site-nav-main');
    if (nav && burger) {
        burger.addEventListener('click', function() {
            nav.classList.toggle('site-nav-expand');
            burger.classList.toggle('burger-open');
            if (navBar) {
                setNewsletterStickyOffset(navBar.classList.contains('nav-hidden'));
            }
        });
    }

    if (!navBar) {
        return;
    }

    var lastScrollY = 0;
    var ticking = false;

    function setNewsletterStickyOffset(navHidden) {
        var offset = navHidden ? '-1px' : navBar.offsetHeight + 'px';
        document.querySelectorAll('.newsletter-sticky').forEach(function(banner) {
            banner.style.top = offset;
        });
    }

    function setNavHidden(hidden) {
        setNewsletterStickyOffset(hidden);

        if (navBar.classList.contains('nav-hidden') === hidden) {
            return;
        }
        navBar.classList.toggle('nav-hidden', hidden);
    }

    function updateNavVisibility() {
        var currentScrollY = Math.max(window.scrollY, 0);
        var revealOffset = navBar.offsetHeight;

        if ((nav && nav.classList.contains('site-nav-expand')) || currentScrollY <= revealOffset) {
            setNavHidden(false);
        } else if (currentScrollY > lastScrollY) {
            setNavHidden(true);
        } else if (currentScrollY < lastScrollY) {
            setNavHidden(false);
        }

        lastScrollY = currentScrollY;
        ticking = false;
    }

    window.addEventListener('scroll', function() {
        if (!ticking) {
            window.requestAnimationFrame(updateNavVisibility);
            ticking = true;
        }
    }, { passive: true });

    window.addEventListener('resize', function() {
        setNewsletterStickyOffset(navBar.classList.contains('nav-hidden'));
    }, { passive: true });

    if (nav) {
        nav.addEventListener('transitionend', function(event) {
            if (event.target === nav && event.propertyName === 'height') {
                setNewsletterStickyOffset(navBar.classList.contains('nav-hidden'));
            }
        });
    }

    document.addEventListener('DOMContentLoaded', function() {
        setNewsletterStickyOffset(navBar.classList.contains('nav-hidden'));
    });

    navBar.addEventListener('focusin', function() {
        setNavHidden(false);
        lastScrollY = Math.max(window.scrollY, 0);
    });

    updateNavVisibility();

})(window, document);
